import { Personnel } from "@/apis/dtos";
import useGetTrialInstitutionCoordinators from "@/hooks/data/useGetTrialInstitutionCoordinators";
import { createContext } from "react";

export interface ITrialInstitutionCoordinatorsContext extends Omit<ReturnType<typeof useGetTrialInstitutionCoordinators>, 'data'> {
    data?: Personnel[]
}

export const TrialInstitutionCoordinatorsContext = createContext<ITrialInstitutionCoordinatorsContext>({
    data: undefined,
    loading: false,
    validating: false,
    error: undefined,
    mutate: async () => { return undefined },
    refresh: async () => { return undefined }
});